import axios from 'axios';
import store from '@/store';
// import { Toast } from 'vant'
// import qs from 'qs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_APP_API,
  // url = base api url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [
    // (data, headers) => {
    //   if (headers['Content-Type'] === 'multipart/form-data') {
    //     return data
    //   }
    //   // 请求之前对参数进行序列化
    //   return qs.stringify(data)
    // }
  ]
});

// request拦截器 request interceptor
service.interceptors.request.use(config => {
  if (store.getters.userXdToken) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.userXdToken;
  }
  return config;
}, error => {
  console.log(error); // for debug
  return Promise.reject(error);
});
// respone拦截器
service.interceptors.response.use(response => {
  const res = response.data;
  if (res.status && res.status !== 200) {
    // 请求异常处理
    return Promise.reject(res || 'error');
  } else {
    return Promise.resolve(res);
  }
}, error => {
  // Toast.fail('服务异常')
  console.log('err' + error); // for debug
  return Promise.reject(error);
});
export default service;